import React from 'react';

interface IconProps {
  className?: string;
}

export const ReplyAllIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className={className}>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <rect x={0} y={0} width={24} height={24} />
        {/* Second (back) arrow */}
        <path
          d="M8.5,4.69307548 L8.5,9 C11.2,9.13671875 13.5,9.43652344 15.0671874,11.1650391 C17.1,13.3 17.2,16.2 17.2,17.7910156 L17.2,19.5 L17.0,19.5 C16.6853,19.5 16.4041,19.3036749 16.2957,19.0083314 C15.4,16.8 14.2,15.2 12.7,14.5 L8.5,14.5 L8.5,17.7831961 C8.5,18.1971097 8.16421356,18.5328961 7.75,18.5328961 C7.5636897,18.5328961 7.384049,18.4635512 7.2460626,18.3383663 L2.30599678,13.8590278 C2.00,13.5807109 1.976147,13.1064 2.2544639,12.7996 C2.26907199,12.7835 2.28437331,12.768 2.30032452,12.7532 L7.2403903,8.05 C7.5442966,7.76855 8.01882,7.78676 8.3002708,8.09066 C8.428669,8.22931 8.5,8.41131 8.5,8.6002 L8.5,4.69307548 Z"
          fill="currentColor"
          fillRule="nonzero"
          opacity="0.4"
        />
        {/* Front arrow */}
        <path
          d="M19.4451171,17.7910156 C19.4451171,16.9707031 19.6208984,13.7333984 17.0671874,11.1650391 C15.3484374,9.43652344 12.7761718,9.13671875 9.6999999,9 L9.6999999,4.69307548 C9.6999999,4.27886191 9.3642135,3.94307548 8.9499999,3.94307548 C8.7636897,3.94307548 8.584049,4.01242035 8.4460626,4.13760526 L1.30599678,10.6152626 C0.99921905,10.8935795 0.976147,11.3678924 1.2544639,11.6746702 C1.26907199,11.6907721 1.28437331,11.7062312 1.30032452,11.7210037 L8.4403903,18.333467 C8.7442966,18.6149166 9.2188212,18.596712 9.5002708,18.2928057 C9.628669,18.1541628 9.6999999,17.9721616 9.6999999,17.7831961 L9.6999999,13.5 C11.6531249,13.5537109 13.0443703,13.6779456 14.3083984,14.0800781 C16.1284272,14.6590944 17.5349747,16.3018455 18.5280411,19.0083314 C18.6363903,19.3036749 18.9175496,19.5 19.2321404,19.5 L19.4499999,19.5 C19.4499999,19.0068359 19.4451171,18.2255859 19.4451171,17.7910156 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
